import { render } from "./PlayerQuery.vue?vue&type=template&id=67e610e1&scoped=true"
import script from "./PlayerQuery.vue?vue&type=script&lang=ts"
export * from "./PlayerQuery.vue?vue&type=script&lang=ts"

import "./PlayerQuery.vue?vue&type=style&index=0&id=67e610e1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67e610e1"

export default script